import { TCartItem } from "Services/Cart/cart";

enum types {
  CLEAR_FILTERS = "CLEAR_FILTERS",
}

export interface TFilters {
  search?: string;
  category?: string;
  subcategory?: string;
  priceRange?: [number, number];
  sortBy?: string;
}

export default types;
